/**
 * Hiérarchie z-index globale — toasts au-dessus de toutes les modales / sidebars.
 * Modales courantes : 9999–10005. Ne pas dépasser TOAST sans raison.
 */
export const Z_INDEX = {
  MODAL: 10000,
  MODAL_OVERLAY: 10002,
  MODAL_CONTENT: 10003,
  MODAL_SHEET: 10005,
  TOAST: 110000,
};

export const TOAST_CONTAINER_STYLE = {
  zIndex: Z_INDEX.TOAST,
};
